module.exports = __webpack_public_path__ + "media/nature.99b1fb4e.wav";